/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Manifest } from './manifest';

export interface CreateWorkflowRequest { 
    manifest?: Manifest;
    projectId?: number;
    definitionType?: CreateWorkflowRequest.DefinitionTypeEnum;
}
export namespace CreateWorkflowRequest {
    export type DefinitionTypeEnum = 'WORKFLOW' | 'HYBRID_RULESET' | 'HYBRID_RULE';
    export const DefinitionTypeEnum = {
        WORKFLOW: 'WORKFLOW' as DefinitionTypeEnum,
        HYBRIDRULESET: 'HYBRID_RULESET' as DefinitionTypeEnum,
        HYBRIDRULE: 'HYBRID_RULE' as DefinitionTypeEnum
    };
}